import { Controller } from '@hotwired/stimulus'
import SwaggerUIBundle from 'swagger-ui-dist/swagger-ui-bundle'

export default class extends Controller {
  static values = { url: {type: String}};

  connect() {
    SwaggerUIBundle({
      dom_id: '#swagger',
      url: this.urlValue,
    })
  }
}
